module.exports = __webpack_public_path__ + "img/img60.76c853d1.svg";